import PropTypes from 'prop-types'
import React from 'react'

export default function CartLayoutTemplate (props) {
  const { colOne, colTwo, colThree = null } = props

  return (
    <div className="cart-layout-template">
      <div className="cart-layout-template__content">
        {!colTwo
          ? <div className="cart-layout-template__center">
              {colOne}
            </div>
          : <>
              <div className="cart-layout-template__left">
                {colOne}
              </div>
              <div className="cart-layout-template__right">
                {colTwo}
              </div>
            </>
        }
      </div>
      {colThree && (
        <div className="cart-layout-template__bottom">
          {colThree}
        </div>
      )}
    </div>
  )
}

CartLayoutTemplate.propTypes = {
  colOne: PropTypes.node.isRequired,
  colTwo: PropTypes.node,
  colThree: PropTypes.node,
}
